import { startAuthentication, startRegistration, browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { api } from "./api.ts";

export const passkeysSupported = () => typeof window !== "undefined" && browserSupportsWebAuthn();

export async function addPasskey(name: string) {
  const o = await api("POST", "/api/v1/auth/passkey/register/options");
  const response = await startRegistration({ optionsJSON: o.options });
  return api("POST", "/api/v1/auth/passkey/register/verify", { challenge_id: o.challenge_id, response, name });
}

export async function signInWithPasskey(opts: { mfaToken?: string; client?: "web" | "guardian_app" | "teacher_app" } = {}) {
  const o = await api("POST", "/api/v1/auth/passkey/login/options", opts.mfaToken ? { mfa_token: opts.mfaToken } : {});
  const response = await startAuthentication({ optionsJSON: o.options });
  return api<{ ok: true; token?: string }>("POST", "/api/v1/auth/passkey/login/verify", { challenge_id: o.challenge_id, response, mfa_token: opts.mfaToken, client: opts.client ?? "web" });
}
